export default __webpack_public_path__ + "static/media/download.25f5edd5.svg";